// extracted by mini-css-extract-plugin
export default {"sidebarLink":"sidebar_sidebarLink__MWJq1"};